<template>
	<div class="setting-activity-content">
		<div class="setting-top-box">
			<span class="setting-top-title">已报名活动</span>
		</div>
		<div class="notice-box">
			<ss-article-list mode="3" :value="curData_" :finish="finish_" :busy="busy_" detailPath="/cultureAround/activity/" />
		</div>
		<div class="right-navigation-box">
			<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
		</div>
	</div>
</template>

<script>
	import ssArticleList from '@/components/ss-article-list/ss-article-list.vue'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		components: {
			ssArticleList
		},
		data() {
			return {
				curPage: 1,
				pageSize: 5,
			}
		},
		methods: {
			goDetail() {
				this.$router.push({
					name: 'settingNoticeDetail'
				})
			}
		}
	}
</script>

<style lang="scss">
	.setting-activity-content{
		.notice-box{
			padding: 30px;
			height: 887px;
			overflow: auto;
			.article-list{
				padding: 0;
				li{
					padding-left: 0;
				}
				.article-img{
					width: 200px;
				}
				.article-right-content{
					width: 618px;
					height: 132px;
					padding-right: 0;
					float: left;
				}
			}
		}
	}
</style>
